<template>

  <v-app id="inspire">
     <v-app-bar
      short
      dense
      clipped-left 
      app
      color="blue darken-3"
      dark
    >
      <v-app-bar-nav-icon @click.stop="drawer = !drawer" />
      <v-toolbar-title        
        class="ml-0 pl-4"
      >
      <span class="hidden-sm-and-down">Flight System</span>
      </v-toolbar-title>
      
      <v-spacer />
      
      <span v-if="this.currentPage=='Create Invoice' && !isCustomerOnly">
        
        <v-btn @click="reset" icon>
           Reset
        </v-btn>
        <v-divider
      class="mx-4"
      vertical
    ></v-divider>
<v-btn icon>
          <v-icon>mdi-mail</v-icon>
        </v-btn>
        <v-btn @click="openPrintProfileDialog" icon title="Print with specific profile">
          <v-icon>mdi-printer-alert</v-icon>
        </v-btn>
        <v-btn @click="directPrintAction" icon title="Print (Default Profile)">
          <v-icon>mdi-printer</v-icon>
        </v-btn>

        <v-btn @click="save" icon>
          <v-icon> mdi-content-save</v-icon>
        </v-btn>
        
      </span>
      <span v-if="this.currentPage=='Sale Invoices'">
        <v-btn @click="postInvoiceAction" icon>
          <v-icon>mdi-send</v-icon>
        </v-btn>
      </span>
      
      <v-divider class="mx-2" vertical></v-divider>

      <!-- Header Inquiry Menu -->
      <v-menu v-if="!isCustomerOnly && canViewInquiries" v-model="showInquiryPopup" bottom offset-y :close-on-content-click="false" max-width="420" nudge-bottom="10">
        <template v-slot:activator="{ on, attrs }">
          <v-btn icon dark v-bind="attrs" v-on="on" title="Inquiries">
            <v-badge :content="openInquiryCount" :value="openInquiryCount > 0" color="orange" overlap>
              <v-icon>mdi-comment-question-outline</v-icon>
            </v-badge>
          </v-btn>
        </template>
        <v-card width="400">
          <v-card-title class="blue darken-3 white--text py-2" style="font-size:16px">
            <v-icon dark class="mr-2">mdi-comment-question-outline</v-icon>
            Inquiries
            <v-spacer></v-spacer>
            <v-btn icon dark small @click="refreshInquiries"><v-icon small>mdi-refresh</v-icon></v-btn>
          </v-card-title>
          <v-list dense class="pa-0" style="max-height:280px; overflow-y:auto">
            <div v-if="recentOpenInquiries.length === 0" class="text-center pa-4 grey--text">No open inquiries</div>
            <div v-for="inq in recentOpenInquiries" :key="inq.id">
              <v-list-item @click="openInquiryPage">
                <v-list-item-icon>
                  <v-icon :color="inquiryPriorityColor(inq.priority)" small>mdi-circle</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title>{{ inq.title }}</v-list-item-title>
                  <v-list-item-subtitle>
                    {{ inq.customerName || (inq.customer ? inq.customer.name : 'Walk-in') }} &middot; {{ inq.category }}
                  </v-list-item-subtitle>
                </v-list-item-content>
                <v-list-item-action>
                  <v-chip x-small color="red" dark>Open</v-chip>
                </v-list-item-action>
              </v-list-item>
              <v-divider></v-divider>
            </div>
          </v-list>
          <v-card-actions>
            <v-btn color="blue darken-3 white--text py-2" dark small @click="openQuickNewInquiry">
              <v-icon left small>mdi-plus</v-icon> New Inquiry
            </v-btn>
            <v-spacer></v-spacer>
            <v-btn text small color="blue darken-3 white--text py-2" @click="openInquiryPage">View All</v-btn>
          </v-card-actions>
        </v-card>
      </v-menu>

      <!-- Header Flight Search Menu -->
      <v-menu v-if="!isCustomerOnly" v-model="showFlightSearch" bottom offset-y :close-on-content-click="false" max-width="420" nudge-bottom="10">
        <template v-slot:activator="{ on, attrs }">
          <v-btn icon dark v-bind="attrs" v-on="on" title="Flight Search">
            <v-icon>mdi-calendar-search</v-icon>
          </v-btn>
        </template>
        <v-card width="400">
          <v-card-title class="blue darken-3 white--text py-2" style="font-size:16px">
            <v-icon dark class="mr-2">mdi-airplane-search</v-icon>
            Search Flights by Date
          </v-card-title>
          <v-card-text class="pt-4 pb-0">
            <v-row align="center" dense>
              <v-col cols="6">
                <v-text-field v-model="searchStartDate" label="From Date" type="date" outlined dense hide-details></v-text-field>
              </v-col>
              <v-col cols="6">
                <v-text-field v-model="searchEndDate" label="To Date" type="date" outlined dense hide-details></v-text-field>
              </v-col>
              <v-col cols="12">
                <v-btn color="blue darken-3" dark block @click="performFlightSearch" :loading="isSearchingFlights">
                  Search
                </v-btn>
              </v-col>
            </v-row>
          </v-card-text>
          <v-list dense v-if="searchFlightsResults.length > 0" class="pa-0 mt-2" style="max-height:300px; overflow-y:auto">
            <v-divider></v-divider>
            <div v-for="(flight, idx) in searchFlightsResults" :key="flight.id">
              <v-list-item @click="openInvoiceFromSearch(flight.invoiceId)">
                <v-list-item-icon>
                  <v-icon :color="flight.invoice.customer.balance > 0 ? 'red' : 'green'" small>mdi-airplane-takeoff</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title>{{ flight.invoice.customer.name }} — INV #{{ flight.invoiceId }}</v-list-item-title>
                  <v-list-item-subtitle>{{ flight.airline }} {{ flight.flightNumber }} | {{ flight.flyFrom }} → {{ flight.flyTo }}</v-list-item-subtitle>
                  <v-list-item-subtitle>
                    <strong>{{ flight.flightDate }}</strong>
                    <span v-if="flight.departureTime"> at {{ flight.departureTime }}</span>
                    <span v-if="flight.invoice.customer.balance > 0" class="red--text ml-2">Balance: £{{ flight.invoice.customer.balance.toFixed(2) }}</span>
                  </v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
              <v-divider v-if="idx < searchFlightsResults.length - 1"></v-divider>
            </div>
          </v-list>
          <v-card-text v-else-if="hasSearchedFlights" class="text-center py-6 mt-2 border-top">
            <v-icon large color="grey lighten-1">mdi-airplane-off</v-icon>
            <p class="mt-2 grey--text mb-0">No flights found on this date</p>
          </v-card-text>
          <v-divider v-if="searchFlightsResults.length > 0"></v-divider>
          <v-card-actions v-if="searchFlightsResults.length > 0">
            <v-btn text small color="primary" @click="goToFlightSearchReport">View Full Report</v-btn>
          </v-card-actions>
        </v-card>
      </v-menu>

      <!-- Header Notification Bell Menu -->
      <v-menu v-if="!isCustomerOnly" v-model="showNotifications" bottom offset-y :close-on-content-click="false" max-width="420" nudge-bottom="10">
        <template v-slot:activator="{ on, attrs }">
          <v-btn icon dark v-bind="attrs" v-on="on" title="Upcoming Flights">
            <v-badge :content="notificationCount" :value="notificationCount > 0" color="red" overlap>
              <v-icon>mdi-bell</v-icon>
            </v-badge>
          </v-btn>
        </template>
        <v-card width="400">
          <v-card-title class="blue darken-3 white--text py-2" style="font-size:16px">
            <v-icon dark class="mr-2">mdi-airplane-clock</v-icon>
            Upcoming Flights (48h)
            <v-spacer></v-spacer>
            <v-btn icon dark small @click="refreshNotifications"><v-icon small>mdi-refresh</v-icon></v-btn>
          </v-card-title>
          <v-list dense v-if="notificationFlights.length > 0" class="pa-0" style="max-height:380px; overflow-y:auto">
            <div v-for="(flight, idx) in notificationFlights" :key="flight.id">
              <v-list-item @click="openInvoice(flight.invoiceId)">
                <v-list-item-icon>
                  <v-icon :color="flight.invoice.customer.balance > 0 ? 'red' : 'green'" small>mdi-airplane-takeoff</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title>{{ flight.invoice.customer.name }} — INV #{{ flight.invoiceId }}</v-list-item-title>
                  <v-list-item-subtitle>{{ flight.airline }} {{ flight.flightNumber }} | {{ flight.flyFrom }} → {{ flight.flyTo }}</v-list-item-subtitle>
                  <v-list-item-subtitle>
                    <strong>{{ flight.flightDate }}</strong>
                    <span v-if="flight.departureTime"> at {{ flight.departureTime }}</span>
                    <span v-if="flight.invoice.customer.balance > 0" class="red--text ml-2">Balance: £{{ flight.invoice.customer.balance.toFixed(2) }}</span>
                  </v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
              <v-divider v-if="idx < notificationFlights.length - 1"></v-divider>
            </div>
          </v-list>
          <v-card-text v-else class="text-center py-6">
            <v-icon large color="blue darken-3">mdi-bell-check-outline</v-icon>
            <p class="mt-2 grey--text">No upcoming flights in the next 48 hours</p>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions>
            <v-btn text small color="primary" @click="goToNotificationPanel">View Full Report</v-btn>
          </v-card-actions>
        </v-card>
      </v-menu>
      
    </v-app-bar>
    <v-navigation-drawer
      v-model="drawer"
      
      temporary
      transitionend="collapseSubItems"
      absolute
      clipped
      hover
      style='top: 50px'
      
    >
       <v-list>
        <template v-for="(n, i) in filteredItems">
              <v-list-item v-if="n.to" :key="`${i}-a`" :to="n.to" link>
                <v-list-item-icon>
                  <v-icon small>{{ n.icon }}</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title>{{ n.title }}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-list-group
                v-if="n.subItems"
                :key="`${i}-b`"
                :prepend-icon="`${n.icon} fa-em`"
                v-model="n.active"
                append-icon="fas fa-chevron-down fa-sm"
              >
                <template v-slot:activator>
                  <v-list-item-content>
                    <v-list-item-title>{{ n.title }}</v-list-item-title>
                  </v-list-item-content>
                </template>
                <v-list-item
                  v-for="(s, y) in n.subItems"
                  :key="y"
                  :to="s.to"
                  link
                  class="pl-8"
                  @click="changePage(s)"
                >
                  <v-list-item-icon>
                    <v-icon small>{{ s.icon }}</v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title>{{ s.title }}</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>                
              </v-list-group>
            </template>
                     <v-list-item link @click="logout">
            <v-list-item-icon>
              <v-icon>mdi-logout</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>Logout</v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          </v-list>
    </v-navigation-drawer>

   
    <!-- ===== Flight SMS Reminder Banner ===== -->
    <v-banner
      v-if="showReminderBanner && isAdmin"
      color="blue darken-3"
      dark
      single-line
      style="position:sticky; top:48px; z-index:5;"
    >
      <v-icon slot="icon" color="white" size="22">mdi-airplane-clock</v-icon>
      <strong>{{ pendingFlightReminders.length }} customer(s)</strong> have flights departing in the next 24 hours and haven&apos;t been notified yet.
      <template v-slot:actions>
        <v-btn text dark small @click="showReminderBanner = false">Dismiss</v-btn>
        <v-btn dark small depressed color="blue darken-3" @click="openReminderDialog">Send SMS Reminders</v-btn>
      </template>
    </v-banner>

    <!-- ===== Flight SMS Reminder Dialog ===== -->
    <v-dialog v-model="showReminderDialog" max-width="700px" persistent>
      <v-card>
        <v-card-title class="blue darken-3 white--text py-3">
          <v-icon dark left>mdi-message-text</v-icon>
          Send Flight SMS Reminders
          <v-spacer></v-spacer>
          <span class="caption white--text">{{ pendingFlightReminders.length }} pending</span>
        </v-card-title>

        <v-card-text class="pt-4 pb-0">
          <p class="body-2 grey--text text--darken-1 mb-2">
            Customize the message template below or keep the default. Select customers to send and click <strong>Confirm &amp; Send</strong>.
          </p>

          <!-- Customizable Template Section -->
          <v-card outlined class="pa-3 mb-3 grey lighten-4">
            <div class="d-flex align-center mb-1">
              <span class="caption font-weight-bold grey--text text--darken-3">
                <v-icon x-small color="blue darken-3" class="mr-1">mdi-pencil-outline</v-icon>
                MESSAGE TEMPLATE
              </span>
              <v-spacer></v-spacer>
              <v-btn text x-small color="primary" @click="resetReminderTemplate">
                <v-icon x-small left>mdi-refresh</v-icon> Reset to Default
              </v-btn>
            </div>

            <v-textarea
              v-model="reminderTemplate"
              rows="3"
              outlined
              dense
              background-color="white"
              placeholder="Enter message template..."
              hint="Use tags below to insert dynamic flight and customer details."
              persistent-hint
              class="caption mb-1"
            ></v-textarea>

            <!-- Placeholder Chips -->
            <div class="mt-2 d-flex flex-wrap align-center" style="gap: 4px;">
              <span class="caption grey--text mr-1">Insert tags:</span>
              <v-chip x-small outlined color="blue darken-3" @click="insertPlaceholder('{name}')">
                {name}
              </v-chip>
              <v-chip x-small outlined color="blue darken-3" @click="insertPlaceholder('{invoiceId}')">
                {invoiceId}
              </v-chip>
              <v-chip x-small outlined color="blue darken-3" @click="insertPlaceholder('{flights}')">
                {flights}
              </v-chip>
              <v-chip x-small outlined color="blue darken-3" @click="insertPlaceholder('{flightDate}')">
                {flightDate}
              </v-chip>
              <v-chip x-small outlined color="blue darken-3" @click="insertPlaceholder('{company}')">
                {company}
              </v-chip>
            </div>

            <!-- Live Sample Preview -->
            <div v-if="reminderPreview" class="mt-3 pa-2 blue lighten-5 rounded" style="border: 1px dashed #90caf9;">
              <div class="caption font-weight-bold blue--text text--darken-3 mb-1">
                <v-icon x-small color="blue darken-3">mdi-eye-outline</v-icon> Live Preview (Sample Recipient):
              </div>
              <div class="caption text--primary" style="white-space: pre-wrap;">{{ reminderPreview }}</div>
            </div>
          </v-card>

          <!-- Select All toggle & list -->
          <div class="d-flex align-center justify-space-between mb-1">
            <span class="caption font-weight-bold grey--text text--darken-3">RECIPIENTS</span>
            <v-checkbox
              v-model="allRemindersSelected"
              label="Select All"
              dense
              hide-details
              color="blue darken-3"
              class="ma-0 pa-0"
              @change="toggleAllReminders"
            ></v-checkbox>
          </div>
          <v-divider class="mb-2"></v-divider>

          <div style="max-height: 240px; overflow-y: auto;" class="pr-1">
            <div
              v-for="reminder in pendingFlightReminders"
              :key="reminder.invoiceId"
              class="reminder-row"
            >
              <v-checkbox
                v-model="selectedReminderIds"
                :value="reminder.invoiceId"
                dense
                hide-details
                color="blue darken-3"
                class="mt-0 mb-1"
              >
                <template v-slot:label>
                  <div style="width: 100%;">
                    <span class="body-2 font-weight-medium">{{ reminder.customer.name }} {{ reminder.customer.surname }}</span>
                    <span class="body-2 grey--text mx-2">—</span>
                    <span class="caption grey--text">INV #{{ reminder.invoiceId }}</span>
                    <span class="caption blue--text text--darken-1 ml-3">
                      <v-icon x-small color="blue darken-1">mdi-phone</v-icon>
                      {{ reminder.customer.mobileNumber || reminder.customer.contactNumber || 'No number' }}
                    </span>
                    <div class="pl-0 mt-1">
                      <div 
                        v-for="flight in reminder.flights" 
                        :key="flight.id"
                        class="caption text--primary"
                      >
                        <v-icon x-small class="mr-1">mdi-airplane</v-icon>
                        {{ flight.flyFrom }} → {{ flight.flyTo }}
                        <span class="grey--text ml-1">({{ flight.flightDate }}{{ flight.departureTime ? ' ' + flight.departureTime : '' }})</span>
                      </div>
                    </div>
                  </div>
                </template>
              </v-checkbox>
              <v-divider class="my-2"></v-divider>
            </div>
          </div>

          <!-- No items state -->
          <div v-if="pendingFlightReminders.length === 0" class="text-center py-4 grey--text">
            No pending reminders found.
          </div>

          <!-- Result message after sending -->
          <v-alert v-if="reminderSendResult" :type="reminderSendResultType" dense class="mt-3">
            {{ reminderSendResult }}
          </v-alert>
        </v-card-text>

        <v-card-actions class="px-4 pb-4">
          <v-btn text @click="closeReminderDialog">Close</v-btn>
          <v-spacer></v-spacer>
          <v-btn
            color="blue darken-3"
            dark
            depressed
            :loading="isSendingReminders"
            :disabled="selectedReminderIds.length === 0 || isSendingReminders"
            @click="confirmSendReminders"
          >
            <v-icon left small>mdi-send</v-icon>
            Confirm &amp; Send to {{ selectedReminderIds.length }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-content>
      
      <transition name="fade" mode="out-in">
      <router-view></router-view>
      </transition>
      
    </v-content>
    <!-- <v-btn
      bottom
      color="pink"
      dark
      fab
      fixed
      right
      @click="dialog = !dialog"
    >
      <v-icon>mdi-plus</v-icon>
    </v-btn>
    <v-dialog
      v-model="dialog"
      width="800px"
    >
      <v-card>
        <v-card-title class="grey darken-2">
          Create contact
        </v-card-title>
        <v-container>
          <v-row class="mx-2">
            <v-col
              class="align-center justify-space-between"
              cols="12"
            >
              <v-row
                align="center"
                class="mr-0"
              >
                <v-avatar
                  size="40px"
                  class="mx-3"
                >
                  <img
                    src="//ssl.gstatic.com/s2/oz/images/sge/grey_silhouette.png"
                    alt=""
                  >
                </v-avatar>
                <v-text-field
                  placeholder="Name"
                />
              </v-row>
            </v-col>
            <v-col cols="6">
              <v-text-field
                prepend-icon="mdi-account-card-details-outline"
                placeholder="Company"
              />
            </v-col>
            <v-col cols="6">
              <v-text-field
                placeholder="Job title"
              />
            </v-col>
            <v-col cols="12">
              <v-text-field
                prepend-icon="mdi-mail"
                placeholder="Email"
              />
            </v-col>
            <v-col cols="12">
              <v-text-field
                type="tel"
                prepend-icon="mdi-phone"
                placeholder="(000) 000 - 0000"
              />
            </v-col>
            <v-col cols="12">
              <v-text-field
                prepend-icon="mdi-text"
                placeholder="Notes"
              />
            </v-col>
          </v-row>
        </v-container>
        <v-card-actions>
          <v-btn
            text
            color="primary"
          >More</v-btn>
          <v-spacer />
          <v-btn
            text
            color="primary"
            @click="dialog = false"
          >Cancel</v-btn>
          <v-btn
            text
            @click="dialog = false"
          >Save</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog> -->

    <!-- Default Notes Editor Overlay -->
    <v-dialog v-model="showNotesDialog" width="600px">
      <v-card>
        <v-card-title class="grey darken-2 white--text">
          Default Invoice Notes
        </v-card-title>
        <v-container>
          <v-textarea
            v-model="notesText"
            label="Notes to show natively upon starting new invoices"
            outlined
            rows="5"
          ></v-textarea>
        </v-container>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="showNotesDialog = false">Cancel</v-btn>
          <v-btn color="primary" text @click="saveDefaultNotes">Save Setting</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- User Permissions Management Dialog -->
    <v-dialog v-model="showUsersDialog" max-width="900px">
      <v-card>
        <v-card-title class="blue darken-3 white--text">
          Manage User Permissions
        </v-card-title>
        <v-container>
          <v-alert v-if="userSaveSuccess" type="success" dense dismissible>Operation completed successfully</v-alert>
          <v-simple-table v-if="$store.state.employees.employees.length > 0">
            <thead>
              <tr>
                <th>Name</th>
                <th>Username</th>
                <th>Admin</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="emp in $store.state.employees.employees" :key="emp.id">
                <td>{{ emp.name }}</td>
                <td>{{ emp.userName }}</td>
                <td>
                  <v-icon small :color="emp.isAdmin ? 'green' : 'grey lighten-1'">{{ emp.isAdmin ? 'mdi-shield-check' : 'mdi-shield-off-outline' }}</v-icon>
                </td>
                <td>
                  <v-btn small color="primary" class="mr-2" @click="editUser(emp)">Edit</v-btn>
                  <v-btn small color="error" @click="confirmDeleteUser(emp)">Delete</v-btn>
                </td>
              </tr>
            </tbody>
          </v-simple-table>
          <div v-else style="text-align:center; padding:20px">
            <v-progress-circular indeterminate color="primary"></v-progress-circular>
            <p>Loading employees...</p>
          </div>
        </v-container>
        <v-card-actions>
          <v-btn color="blue darken-3" dark @click="openCreateUserDialog">
            <v-icon left>mdi-account-plus</v-icon> New User
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn text @click="showUsersDialog = false">Close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Edit User Dialog (Center Box) -->
    <v-dialog v-model="showEditUserDialog" max-width="600px">
      <v-card v-if="selectedUser">
        <v-card-title class="blue darken-3--text">
          Edit Permissions - {{ selectedUser.name }}
        </v-card-title>
        <v-container>
          <v-row>
            <v-col cols="12" sm="6"><v-checkbox v-model="selectedUser.isAdmin" label="Admin" dense hide-details></v-checkbox></v-col>
            <v-col cols="12" sm="6"><v-checkbox v-model="selectedUser.isCreateInvoice" label="Create Invoice" dense hide-details></v-checkbox></v-col>
            <v-col cols="12" sm="6"><v-checkbox v-model="selectedUser.isUpdateInvoice" label="Update Invoice" dense hide-details></v-checkbox></v-col>
            <v-col cols="12" sm="6"><v-checkbox v-model="selectedUser.isPostInvoice" label="Post Invoice" dense hide-details></v-checkbox></v-col>
            <v-col cols="12" sm="6"><v-checkbox v-model="selectedUser.isAddPayment" label="Add Payment" dense hide-details></v-checkbox></v-col>
            <v-col cols="12" sm="6"><v-checkbox v-model="selectedUser.isViewLedger" label="View Ledger" dense hide-details></v-checkbox></v-col>
            <v-col cols="12" sm="6"><v-checkbox v-model="selectedUser.isViewCash" label="View Cash" dense hide-details></v-checkbox></v-col>
            <v-col cols="12" sm="6"><v-checkbox v-model="selectedUser.isViewStatistics" label="View Stats" dense hide-details></v-checkbox></v-col>
            <v-col cols="12" sm="6"><v-checkbox v-model="selectedUser.isCustomerOnly" label="Customer Only" dense hide-details></v-checkbox></v-col>
            <v-col cols="12" sm="6"><v-checkbox v-model="selectedUser.isViewInquiries" label="View Inquiries" dense hide-details></v-checkbox></v-col>
          </v-row>
          <v-row class="mt-4">
            <v-col cols="12">
              <!-- IMPORTANT: do NOT bind to selectedUser.password — bind to a separate local field
                   to prevent browser autofill from silently overwriting the user's DB password. -->
              <v-text-field
                v-model="editUserPassword"
                type="password"
                label="New Password"
                placeholder="Leave empty to keep current password"
                outlined dense hide-details
                autocomplete="new-password"
              ></v-text-field>
            </v-col>
          </v-row>
        </v-container>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="showEditUserDialog = false">Cancel</v-btn>
          <v-btn color="primary" @click="saveSelectedUserPermissions">Save</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Create User Dialog -->
    <v-dialog v-model="showCreateUserDialog" max-width="620px" persistent>
      <v-card>
        <v-card-title class="blue darken-3 white--text">
          <v-icon left dark>mdi-account-plus</v-icon>
          Create New User
        </v-card-title>
        <v-container class="pt-4">
          <v-alert v-if="createUserError" type="error" dense dismissible @input="createUserError = null">{{ createUserError }}</v-alert>
          <v-row>
            <v-col cols="12" sm="6">
              <v-text-field v-model="newUser.name" label="Full Name *" outlined dense hide-details></v-text-field>
            </v-col>
            <v-col cols="12" sm="6">
              <v-text-field v-model="newUser.userName" label="Username *" outlined dense hide-details></v-text-field>
            </v-col>
            <v-col cols="12" sm="6">
              <v-text-field v-model="newUser.password" type="password" label="Password *" outlined dense hide-details></v-text-field>
            </v-col>
            <v-col cols="12" sm="6">
              <v-text-field v-model="newUser.contactNumber" label="Contact Number" outlined dense hide-details></v-text-field>
            </v-col>
            <v-col cols="12" sm="6">
              <v-text-field v-model="newUser.mobileNumber" label="Mobile Number" outlined dense hide-details></v-text-field>
            </v-col>
            <v-col cols="12" sm="6">
              <v-text-field v-model="newUser.address" label="Address" outlined dense hide-details></v-text-field>
            </v-col>
            <v-col cols="12" sm="6">
              <v-text-field v-model="newUser.city" label="City" outlined dense hide-details></v-text-field>
            </v-col>
            <v-col cols="12" sm="6">
              <v-text-field v-model="newUser.postCode" label="Post Code" outlined dense hide-details></v-text-field>
            </v-col>
          </v-row>
          <v-divider class="my-4"></v-divider>
          <p class="subtitle-2 mb-1 grey--text text--darken-1">Assign Permissions</p>
          <v-row dense>
            <v-col cols="12" sm="6"><v-checkbox v-model="newUser.isAdmin" label="Admin" dense hide-details></v-checkbox></v-col>
            <v-col cols="12" sm="6"><v-checkbox v-model="newUser.isCreateInvoice" label="Create Invoice" dense hide-details></v-checkbox></v-col>
            <v-col cols="12" sm="6"><v-checkbox v-model="newUser.isUpdateInvoice" label="Update Invoice" dense hide-details></v-checkbox></v-col>
            <v-col cols="12" sm="6"><v-checkbox v-model="newUser.isPostInvoice" label="Post Invoice" dense hide-details></v-checkbox></v-col>
            <v-col cols="12" sm="6"><v-checkbox v-model="newUser.isAddPayment" label="Add Payment" dense hide-details></v-checkbox></v-col>
            <v-col cols="12" sm="6"><v-checkbox v-model="newUser.isViewLedger" label="View Ledger" dense hide-details></v-checkbox></v-col>
            <v-col cols="12" sm="6"><v-checkbox v-model="newUser.isViewCash" label="View Cash" dense hide-details></v-checkbox></v-col>
            <v-col cols="12" sm="6"><v-checkbox v-model="newUser.isViewStatistics" label="View Stats" dense hide-details></v-checkbox></v-col>
            <v-col cols="12" sm="6"><v-checkbox v-model="newUser.isCustomerOnly" label="Customer Only" dense hide-details></v-checkbox></v-col>
            <v-col cols="12" sm="6"><v-checkbox v-model="newUser.isViewInquiries" label="View Inquiries" dense hide-details></v-checkbox></v-col>
          </v-row>
        </v-container>
        <v-card-actions class="pa-4">
          <v-spacer></v-spacer>
          <v-btn text @click="showCreateUserDialog = false">Cancel</v-btn>
          <v-btn color="blue darken-3" dark :loading="isCreatingUser" @click="submitCreateUser">Create User</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Delete User Confirmation Dialog -->
    <v-dialog v-model="showDeleteConfirmDialog" max-width="420px" persistent>
      <v-card>
        <v-card-title class="red darken-2 white--text">
          <v-icon left dark>mdi-account-remove</v-icon>
          Confirm Delete
        </v-card-title>
        <v-card-text class="pt-4" v-if="userToDelete">
          <v-alert v-if="deleteUserError" type="error" dense dismissible @input="deleteUserError = null">
            {{ deleteUserError }}
          </v-alert>
          Are you sure you want to delete <strong>{{ userToDelete.name }}</strong> (<em>{{ userToDelete.userName }}</em>)? This action cannot be undone.
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="showDeleteConfirmDialog = false">Cancel</v-btn>
          <v-btn color="error" :loading="isDeletingUser" @click="executeDeleteUser">Delete</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Company Profiles Management Dialog -->
    <v-dialog v-model="showProfilesDialog" max-width="750px">
      <v-card>
        <v-card-title class="blue darken-3 white--text">
          <v-icon left dark>mdi-domain</v-icon>
          Company Profiles
          <v-spacer></v-spacer>
          <v-btn dark text @click="openCreateProfile">
            <v-icon left>mdi-plus</v-icon> Add Profile
          </v-btn>
        </v-card-title>
        <v-container>
          <v-simple-table v-if="$store.state.companyProfiles.profiles.length > 0">
            <thead>
              <tr>
                <th>Name</th>
                <th>Address</th>
                <th>Default</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="profile in $store.state.companyProfiles.profiles" :key="profile.id">
                <td>{{ profile.name }}</td>
                <td>{{ profile.address }}</td>
                <td>
                  <v-chip v-if="profile.isDefault" small color="green" dark>Default</v-chip>
                </td>
                <td>
                  <v-btn icon small @click="openEditProfile(profile)"><v-icon small>mdi-pencil</v-icon></v-btn>
                  <v-btn icon small @click="setDefaultProfile(profile.id)" v-if="!profile.isDefault"><v-icon small>mdi-star-outline</v-icon></v-btn>
                  <v-btn icon small @click="confirmDeleteProfile(profile.id)" v-if="!profile.isDefault"><v-icon small color="red">mdi-delete</v-icon></v-btn>
                </td>
              </tr>
            </tbody>
          </v-simple-table>
          <div v-else style="text-align:center; padding:20px">
            <p>No profiles created yet. Click "Add Profile" to create one.</p>
          </div>
        </v-container>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="showProfilesDialog = false">Close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Profile Create/Edit Form Dialog -->
    <v-dialog v-model="showProfileFormDialog" max-width="600px" persistent>
      <v-card>
        <v-card-title class="blue darken-3 white--text">
          {{ editingProfile ? 'Edit Profile' : 'Create New Profile' }}
        </v-card-title>
        <v-container>
          <v-alert v-if="profileSaveError" type="error" dense dismissible>{{ profileSaveError }}</v-alert>
          <v-text-field v-model="profileForm.name" label="Company Name *" outlined dense></v-text-field>
          <v-text-field v-model="profileForm.address" label="Address" outlined dense></v-text-field>
          <v-text-field v-model="profileForm.telephone" label="Telephone" outlined dense></v-text-field>
          <v-text-field v-model="profileForm.website" label="Website" outlined dense></v-text-field>
          <v-text-field v-model="profileForm.email" label="Email" outlined dense></v-text-field>
          <v-checkbox v-model="profileForm.isDefault" label="Set as Default Profile" dense></v-checkbox>
          <p class="subtitle-2 mb-1">Logo</p>
          <input type="file" accept="image/*" @change="onLogoFileChange" />
          <div v-if="profileForm.logo" class="mt-2">
            <img :src="profileForm.logo" height="80px" style="border:1px solid #ccc; padding:4px;" />
          </div>
        </v-container>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="showProfileFormDialog = false">Cancel</v-btn>
          <v-btn color="primary" @click="saveProfile">Save</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Print Profile Selector Dialog -->
    <v-dialog v-model="showPrintProfileDialog" max-width="400px">
      <v-card>
        <v-card-title class="blue darken-3 white--text">
          <v-icon left dark>mdi-printer</v-icon>
          Select Company Profile
        </v-card-title>
        <v-container>
          <v-select
            v-model="printSelectedProfileId"
            :items="$store.state.companyProfiles.profiles"
            item-text="name"
            item-value="id"
            label="Print as"
            outlined
            dense
          ></v-select>
        </v-container>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="showPrintProfileDialog = false">Cancel</v-btn>
          <v-btn color="primary" @click="applyPrintProfile">Apply Profile</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>



    <!-- Quick New Inquiry Dialog (from FAB) -->
    <v-dialog v-model="showQuickInquiryDialog" max-width="560px" persistent>
  <v-card>
    
    <v-card-title class="blue darken-3 white--text py-2">
      <v-icon dark left>mdi-comment-plus-outline</v-icon>
      New Inquiry
    </v-card-title>

    <v-container class="pt-3">

      <v-alert
        v-if="quickInquiryError"
        type="error"
        dense
        dismissible
        @input="quickInquiryError = null"
      >
        {{ quickInquiryError }}
      </v-alert>

      <v-row>

        <!-- Title -->
        <v-col cols="12">
          <v-text-field
            v-model="quickInquiry.title"
            label="Title / Subject *"
            outlined
            dense
            hide-details
          ></v-text-field>
        </v-col>

        <!-- Category -->
        <v-col cols="12" sm="6">
          <v-select
            v-model="quickInquiry.category"
            :items="inquiryCategories"
            label="Category"
            outlined
            dense
            hide-details
            @change="onQuickCategoryChange"
          ></v-select>
        </v-col>

        <!-- Custom Category -->
        <v-col cols="12" sm="6" v-if="quickInquiry.category === 'Other'">
          <v-text-field
            v-model="quickInquiry.customCategory"
            label="Specify Category"
            outlined
            dense
            hide-details
          ></v-text-field>
        </v-col>

        <!-- Priority -->
        <v-col cols="12" sm="6">
          <v-select
            v-model="quickInquiry.priority"
            :items="['Low','Medium','High','Urgent']"
            label="Priority"
            outlined
            dense
            hide-details
          ></v-select>
        </v-col>

        <!-- Flight Dates -->
        <v-col cols="12" sm="6" v-if="quickInquiry.category === 'Flight Booking' || quickInquiry.category === 'Ticket Cancellation' || quickInquiry.category === 'Ticket Refund'">
          <v-text-field
            v-model="quickInquiry.flightStartDate"
            label="Flight Start Date"
            type="date"
            outlined
            dense
            hide-details
          ></v-text-field> 
        </v-col>
        <v-col cols="12" sm="6" v-if="quickInquiry.category === 'Flight Booking' || quickInquiry.category === 'Ticket Cancellation' || quickInquiry.category === 'Ticket Refund'">
          <v-text-field
            v-model="quickInquiry.flightEndDate"
            label="Flight End Date"
            type="date"
            outlined
            dense
            hide-details
          ></v-text-field>
        </v-col>

        <!-- Description -->
        <v-col cols="12">
          <v-textarea
            v-model="quickInquiry.description"
            label="Description"
            outlined
            dense
            rows="3"
            hide-details
          ></v-textarea>
        </v-col>

        <!-- Attachment -->
        <v-col cols="12">
          <v-file-input
            label="Add Attachment(s)"
            outlined
            dense
            hide-details
            prepend-icon="mdi-paperclip"
            multiple
            @change="onQuickAddAttachments"
          ></v-file-input>
          <div v-if="quickInquiry.attachments && quickInquiry.attachments.length > 0" class="attachment-preview-container">
            <div
              v-for="(file, i) in quickInquiry.attachments"
              :key="'q-att-'+i"
              class="attachment-preview-card"
            >
              <a :href="getLocalFileUrl(file)" target="_blank" class="preview-link">
                <img
                  v-if="isLocalImage(file)"
                  :src="getLocalFileUrl(file)"
                  class="preview-img"
                  alt="preview"
                />
                <div v-else class="preview-file-placeholder">
                  <v-icon large color="grey darken-1">mdi-file-document-outline</v-icon>
                  <span class="preview-file-ext">{{ getFileExtension(file.name) }}</span>
                </div>
                <div class="preview-overlay">
                  <v-icon dark small>mdi-open-in-new</v-icon>
                </div>
              </a>
              <span class="preview-filename text-truncate" :title="file.name">{{ file.name }}</span>
              <v-btn
                icon
                x-small
                class="preview-remove-btn"
                color="red"
                @click="removeQuickAttachment(i)"
              >
                <v-icon x-small>mdi-close</v-icon>
              </v-btn>
            </div>
          </div>
        </v-col>

      </v-row>

      <v-divider class="my-3"></v-divider>

      <p class="subtitle-2 mb-2 grey--text text--darken-1">
        Customer Details
      </p>

      <v-row>

        <!-- Customer Name -->
        <v-col cols="12" sm="6">
          <v-combobox
            v-model="quickInquiry.customerName"
            :items="$store.state.customers.allCustomers.items || []"
            item-text="name"
            :filter="customerFilter"
            return-object
            label="Customer Name (Search or Type)"
            outlined
            dense
            clearable
            hide-details
            @change="onQuickCustomerSelect"
          ></v-combobox>
        </v-col>

        <!-- Phone -->
        <v-col cols="12" sm="6">
          <v-combobox
            v-model="quickInquiry.customerPhone"
            :items="$store.state.customers.allCustomers.items || []"
            :filter="phoneFilter"
            :item-text="getPhoneDisplay"
            return-object
            label="Phone (Search or Type)"
            outlined
            dense
            clearable
            hide-details
            @change="onQuickCustomerPhoneSelect"
          ></v-combobox>
        </v-col>

        <!-- Email -->
        <v-col cols="12" sm="6">
          <v-text-field
            v-model="quickInquiry.customerEmail"
            label="Email"
            outlined
            dense
            hide-details
          ></v-text-field>
        </v-col>

      </v-row>

    </v-container>

    <v-card-actions class="pa-4">
      <v-spacer></v-spacer>

      <v-btn text @click="showQuickInquiryDialog = false"> Cancel
      </v-btn> 
      <v-btn color="blue darken-3" dark :loading="isCreatingQuickInquiry" @click="submitQuickInquiry">Create</v-btn>
    </v-card-actions>
  </v-card>
</v-dialog>





  </v-app>
</template>

<script>
  import router from './../router'
  import { mapActions, mapState } from 'vuex'
  import { EventBus } from './../eventbus/event-bus.js';
  import { ledgerService } from './../services/';
  import { smsService } from './../services/sms.sevice';
  export default {

    name: 'Home',
    data: () => ({
      showNavigation: false,
      showSidepanel: false,
      showNotesDialog: false,
      notesText: '',
      showUsersDialog: false,
      showEditUserDialog: false,
      selectedUser: null,
      userSaveSuccess: false,
      // Create User
      showCreateUserDialog: false,
      isCreatingUser: false,
      createUserError: null,
      newUser: {
        name: '', userName: '', password: '', contactNumber: '',
        mobileNumber: '', address: '', city: '', postCode: '',
        isAdmin: false, isCreateInvoice: false, isUpdateInvoice: false,
        isPostInvoice: false, isAddPayment: false, isViewLedger: false,
        isViewCash: false, isViewStatistics: false, isCustomerOnly: false,
        isViewInquiries: false
      },
      // Delete User
      showDeleteConfirmDialog: false,
      userToDelete: null,
      isDeletingUser: false,
      deleteUserError: null,
      // Inquiries FAB
      showInquiryPopup: false,
      showQuickInquiryDialog: false,
      isCreatingQuickInquiry: false,
      quickInquiryError: null,
      // Separate field for the Edit User password — keeps it out of selectedUser
      // so browser autofill CANNOT silently overwrite a user's saved password
      editUserPassword: '',
      quickInquiry: { title: '',category: '',customCategory: '',priority: 'Medium',status: 'New',description: '',customerName: '',customerPhone: '',customerEmail: '', attachments: [] },
      inquiryCategories: ['Flight Booking','Ticket Cancellation','Ticket Refund','Visa Inquiry','Baggage Query','Payment / Invoice','Travel Insurance','Hotel / Accommodation','Umrah Package','General Support','Other'],
      // Notifications
      showNotifications: false,
      notificationPollTimer: null,
      showFlightSearch: false,
      searchStartDate: null,
      searchEndDate: null,
      searchFlightsResults: [],
      isSearchingFlights: false,
      hasSearchedFlights: false,
      // Company Profiles
      showProfilesDialog: false,
      showProfileFormDialog: false,
      editingProfile: null,
      profileForm: { name: '', address: '', telephone: '', website: '', email: '', logo: '', isDefault: false },
      profileSaveError: null,
      // Print profile selector
      showPrintProfileDialog: false,
      printSelectedProfileId: null,

      item:1,
      dialog: false,
      drawer: null,
      source:null,
      // --- Flight SMS Reminder ---
      pendingFlightReminders: [],
      showReminderBanner: false,
      showReminderDialog: false,
      selectedReminderIds: [],
      allRemindersSelected: false,
      isSendingReminders: false,
      reminderSendResult: null,
      reminderSendResultType: 'success',
      reminderTemplate: 'Dear {name}, reminder for your upcoming flight(s) on Invoice #{invoiceId}: {flights}. Contact TravelCo for queries.',
      defaultReminderTemplate: 'Dear {name}, reminder for your upcoming flight(s) on Invoice #{invoiceId}: {flights}. Contact TravelCo for queries.',
      items: [
      { title: 'Accounts', icon: 'mdi-account-box',to:'',subItems:[],active:false },
      { title: 'Invoices', icon: 'mdi-printer-pos',to:'',active:true, subItems:[ { title: 'Create Invoice', icon: 'mdi-printer-pos',to:''}]},
      { title: 'Paid In - Out', icon: 'mdi-home',to:'',subItems:[] ,active:false},
      { title: 'Ledger', icon: 'mdi-book',to:'',subItems:[ { title: 'Assets', icon: 'mdi-evernote',to:''},{ title: 'DailyReport', icon: 'mdi-evernote',to:''},{ title: 'CostReport', icon: 'mdi-evernote',to:''},{ title: 'Ledger Invoices', icon: 'mdi-book-open-page-variant',to:''}],active:false},
      { title: 'Post Ledger', icon: 'mdi-send',active:false, subItems:[ { title: 'Sale Invoices', icon: 'mdi-send',to:''}]},
      { title: 'File Accounts', icon: 'mdi-file-table',to:'',subItems:[],active:false },
      { title: 'Refunds', icon: 'mdi-alert-circle',to:'',subItems:[{ title: 'Refund Report', icon: 'mdi-alert-circle',to:''}],active:false },
      { title: 'Reports', icon: 'mdi-bookshelf',to:'',subItems:[ { title: 'Cash Book', icon: 'mdi-bookshelf',to:''},{ title: 'Invoice Report', icon: 'mdi-bookshelf',to:''}],active:false },
      { title: 'Summaries', icon: 'mdi-chart-pie',to:'',subItems:[] ,active:false},
      { title: 'Inquiries', icon: 'mdi-comment-question-outline', to: '/inquiries', active: false, requiresInquiries: true },
      { title: 'Notifications', icon: 'mdi-bell-ring', to: '/notificationpanel', active: false },
      { title: 'Activity Logs', icon: 'mdi-shield-account', to: '/activitylogs', active: false, adminOnly: true },
      { title: 'Settings', icon: 'mdi-cog', to:'', active:false, subItems:[ { title: 'Default Notes', icon: 'mdi-note',to:''}, { title: 'Company Profiles', icon: 'mdi-domain',to:''}, { title: 'Manage Users', icon: 'mdi-account-cog',to:''}] },
      { title: 'SMS', icon: 'mdi-message-text', to: '/sms', active: false }
    ],
    }),    
    computed: {
      ...mapState('app', ['currentPage']),
      isCustomerOnly () {
        return this.$store.getters['account/isCustomerOnly']
      },
      isAdmin () {
        return this.$store.getters['account/isAdmin']
      },
      filteredItems () {
        const isAdmin = this.$store.getters['account/isAdmin']
        const isCustOnly = this.$store.getters['account/isCustomerOnly']
        const canInquiries = this.$store.getters['account/canViewInquiries']

        let itemsToReturn = this.items;

        if (isCustOnly && !isAdmin) {
          itemsToReturn = itemsToReturn.filter(item => item.title === 'Invoices')
        }

        return itemsToReturn
          .filter(item => !item.adminOnly || isAdmin)               // hide adminOnly items from non-admins
          .filter(item => !item.requiresInquiries || canInquiries)  // hide inquiries from users without permission
          .map(item => {
            if (item.title === 'Settings' && item.subItems) {
              const filtered = item.subItems.filter(sub => {
                if (sub.title === 'Manage Users' || sub.title === 'Company Profiles') {
                  return isAdmin
                }
                return true
              })
              return { ...item, subItems: filtered }
            }
            return item
          })
      },
      notificationCount () {
        return this.$store.state.notifications.count
      },
      notificationFlights () {
        return this.$store.state.notifications.flights
      },
      openInquiryCount () {
        return this.$store.getters['inquiries/openCount']
      },
      recentOpenInquiries () {
        return this.$store.getters['inquiries/recentOpen']
      },
      canViewInquiries () {
        return this.$store.getters['account/canViewInquiries']
      },
      reminderPreview () {
        if (!this.pendingFlightReminders || this.pendingFlightReminders.length === 0) return '';
        const target = this.pendingFlightReminders.find(r => this.selectedReminderIds.includes(r.invoiceId)) || this.pendingFlightReminders[0];
        if (!target) return '';
        const name = [target.customer.name, target.customer.surname].filter(Boolean).join(' ') || target.customer.name || 'Customer';
        const flightLines = (target.flights || []).map(f => `${f.flyFrom || '?'} → ${f.flyTo || '?'} on ${f.flightDate}`).join(', ');
        const tmpl = (this.reminderTemplate && this.reminderTemplate.trim()) ? this.reminderTemplate : this.defaultReminderTemplate;
        return tmpl
          .replace(/\{name\}/gi, name)
          .replace(/\{customerName\}/gi, name)
          .replace(/\{invoiceId\}/gi, target.invoiceId)
          .replace(/\{flights\}/gi, flightLines)
          .replace(/\{route\}/gi, flightLines)
          .replace(/\{flightDate\}/gi, (target.flights && target.flights[0] && target.flights[0].flightDate) || '')
          .replace(/\{company\}/gi, 'TravelCo');
      }
    },
    mounted() {        
        let pagePathDicts={"/invoices":"Create Invoice","/posttoledger":"Sale Invoices"}        
        let currentPath = this.$router.currentRoute.path                
        this.pageDidChange(pagePathDicts[currentPath])
         // Fetch settings early in the background
        this.$store.dispatch('settings/fetchDefaultInvoiceNotes');
        this.$store.dispatch('companyProfiles/fetchProfiles');
        // Fetch notification data and start polling every 5 minutes
        this.$store.dispatch('notifications/fetchUpcoming');
        this.$store.dispatch('inquiries/fetchAll');
        // Fetch pending flight SMS reminders (admin only)
        this.fetchPendingReminders();
        this.notificationPollTimer = setInterval(() => {
          this.$store.dispatch('notifications/fetchUpcoming');
          // Re-check pending reminders on the same poll cycle
          this.fetchPendingReminders();
        }, 5 * 60 * 1000);
    },
    watch: {
      '$route.path': function (newPath) {
        const pagePathDicts = { "/invoices": "Create Invoice", "/posttoledger": "Sale Invoices" };
        if (pagePathDicts[newPath]) {
          this.pageDidChange(pagePathDicts[newPath]);
        }
      }
    },      
    methods: {
      ...mapActions('account', ['logout']),
      ...mapActions('app', ['pageDidChange']),
      changePage (page) {
        console.log(page.title);
        //notes statement
        if(page.title==="Default Notes") {
          // Pre-populate modal interface
          this.notesText = this.$store.state.settings.defaultInvoiceNotes;
          this.showNotesDialog = true;
          this.showSidepanel = false;
          this.showNavigation = false;
          return;
        }
        if(page.title==="Manage Users") {
          if (!this.$store.getters['account/isAdmin']) {
            return;
          }
          this.$store.dispatch('employees/fetchEmployees');
          this.showUsersDialog = true;
          this.showSidepanel = false;
          this.showNavigation = false;
          return;
        }
        if(page.title==="Company Profiles") {
          this.$store.dispatch('companyProfiles/fetchProfiles');
          this.showProfilesDialog = true;
          this.showSidepanel = false;
          this.showNavigation = false;
          return;
        }
        if(page.title==="Sms") {
          router.push("sms")
        }
        else if(page.title==="Create Invoice") {
          router.push("invoices")
        }
        else if(page.title==="Sale Invoices") {
          router.push("posttoledger")
        }
        else if(page.title==="Assets") {
          router.push("assets")
        }        
       else if(page.title==="DailyReport") {
          router.push("dailyreport")
        } 
        else if(page.title==="CostReport") {
          router.push("costreport")
        }
        else if(page.title==="Ledger Invoices") {
          router.push("ledgerinvoices")
        } 
        else if(page.title==="Notification Panel") {
          router.push("notificationpanel")
        }  
        else if(page.title==="Invoice Report") {
          router.push("invoicereport")
        }  
         else if(page.title==="Refund Report") {
          router.push("refundreport")
        }
        else if(page.title==="Inquiries") {
          this.$store.dispatch('inquiries/fetchAll');
          router.push("inquiries")
        }
        
        this.pageDidChange(page.title)
        this.showSidepanel = false
        this.showNavigation = false
      },
      save () {
        console.log("save");
        EventBus.$emit('invoiceSaveAction');
      },
      reset () {
        console.log("reset");
        EventBus.$emit('resetInvoice');
      },
      directPrintAction () {
        // Emit print events directly - will use whatever profile is currently active in Vuex
        this.$nextTick(() => {
          EventBus.$emit('PrePrintAction');
          EventBus.$emit('invoicePrintAction');
        });
      },
      openPrintProfileDialog () {
        // Show profile selector before printing
        this.$store.dispatch('companyProfiles/fetchProfiles');
        const def = this.$store.getters['companyProfiles/defaultProfile'];
        this.printSelectedProfileId = def ? def.id : null;
        this.showPrintProfileDialog = true;
      },
      applyPrintProfile () {
        // Find selected profile and set it as active, but do NOT print yet
        const profiles = this.$store.state.companyProfiles.profiles;
        const selected = profiles.find(p => p.id === this.printSelectedProfileId) || null;
        this.$store.dispatch('companyProfiles/selectProfileForPrint', selected);
        this.showPrintProfileDialog = false;
      },
      postInvoiceAction() {
          EventBus.$emit('postInvoiceAction');
      },
      logoutApp () {
        this.logout()
      },
      saveDefaultNotes() {
        this.$store.dispatch('settings/saveDefaultInvoiceNotes', this.notesText).then(() => {
          this.showNotesDialog = false;
        });
      },
      // ---- Company Profile Methods ----
      openCreateProfile () {
        this.profileForm = { name: '', address: '', telephone: '', website: '', email: '', logo: '', isDefault: false };
        this.editingProfile = null;
        this.profileSaveError = null;
        this.showProfileFormDialog = true;
      },
      openEditProfile (profile) {
        this.profileForm = JSON.parse(JSON.stringify(profile));
        this.editingProfile = profile;
        this.profileSaveError = null;
        this.showProfileFormDialog = true;
      },
      saveProfile () {
        if (!this.profileForm.name) {
          this.profileSaveError = 'Profile name is required';
          return;
        }
        this.profileSaveError = null;
        if (this.editingProfile) {
          this.$store.dispatch('companyProfiles/updateProfile', this.profileForm).then(() => {
            this.showProfileFormDialog = false;
          });
        } else {
          this.$store.dispatch('companyProfiles/createProfile', this.profileForm).then(() => {
            this.showProfileFormDialog = false;
          });
        }
      },
      confirmDeleteProfile (id) {
        this.$store.dispatch('companyProfiles/deleteProfile', id);
      },
      setDefaultProfile (id) {
        this.$store.dispatch('companyProfiles/setDefault', id);
      },
      onLogoFileChange (event) {
        const file = event.target.files[0];
        if (!file) return;
        const reader = new FileReader();
        reader.onload = (e) => {
          this.profileForm.logo = e.target.result;
        };
        reader.readAsDataURL(file);
      },
      editUser(emp) {
        this.selectedUser = JSON.parse(JSON.stringify(emp));
        // Always clear the password field when opening — never pre-fill it
        delete this.selectedUser.password;  // remove any stale field from the copy
        this.editUserPassword = '';          // reset our separate local binding
        this.showEditUserDialog = true;
      },
      saveSelectedUserPermissions() {
        // Only attach the password to the payload when the admin explicitly typed one
        const payload = { ...this.selectedUser };
        const trimmedPw = (this.editUserPassword || '').trim();
        if (trimmedPw) {
          payload.password = trimmedPw;
        } else {
          delete payload.password; // belt-and-suspenders: ensure backend won't touch it
        }
        this.saveUserPermissions(payload);
        this.editUserPassword = '';  // clear after save
        this.showEditUserDialog = false;
      },
      openCreateUserDialog() {
        this.newUser = {
          name: '', userName: '', password: '', contactNumber: '',
          mobileNumber: '', address: '', city: '', postCode: '',
          isAdmin: false, isCreateInvoice: false, isUpdateInvoice: false,
          isPostInvoice: false, isAddPayment: false, isViewLedger: false,
          isViewCash: false, isViewStatistics: false
        };
        this.createUserError = null;
        this.showCreateUserDialog = true;
      },
      async submitCreateUser() {
        if (!this.newUser.name || !this.newUser.userName || !this.newUser.password) {
          this.createUserError = 'Name, username, and password are required.';
          return;
        }
        this.isCreatingUser = true;
        this.createUserError = null;
        try {
          await this.$store.dispatch('employees/createEmployee', this.newUser);
          this.showCreateUserDialog = false;
          this.userSaveSuccess = true;
          setTimeout(() => { this.userSaveSuccess = false; }, 3000);
        } catch (err) {
          this.createUserError = err || 'Failed to create user. Username may already exist.';
        } finally {
          this.isCreatingUser = false;
        }
      },
      confirmDeleteUser(emp) {
        this.userToDelete = emp;
        this.deleteUserError = null;
        this.showDeleteConfirmDialog = true;
      },
      async executeDeleteUser() {
        if (!this.userToDelete) return;
        this.isDeletingUser = true;
        this.deleteUserError = null;
        try {
          await this.$store.dispatch('employees/deleteEmployee', this.userToDelete.id);
          this.showDeleteConfirmDialog = false;
          this.userToDelete = null;
          this.userSaveSuccess = true;
          setTimeout(() => { this.userSaveSuccess = false; }, 3000);
        } catch (err) {
          this.deleteUserError = err || 'Failed to delete user';
          console.error('Failed to delete user:', err);
        } finally {
          this.isDeletingUser = false;
        }
      },
      saveUserPermissions(employee) {
        this.userSaveSuccess = false;
        this.$store.dispatch('employees/saveEmployeePermissions', employee).then(() => {
          this.userSaveSuccess = true;
          setTimeout(() => { this.userSaveSuccess = false; }, 3000);
        });
      },
      refreshNotifications () {
        this.$store.dispatch('notifications/fetchUpcoming');
      },
      openInvoice (invoiceId) {
        this.showNotifications = false;
        this.$router.push('/invoices');
        this.$nextTick(() => {
          EventBus.$emit('loadInvoiceById', invoiceId);
        });
      },
      goToNotificationPanel () {
        this.showNotifications = false;
        this.$router.push('notificationpanel');
        this.pageDidChange('Notification Panel');
      },
      async performFlightSearch() {
        if (!this.searchStartDate || !this.searchEndDate) return;
        this.isSearchingFlights = true;
        this.hasSearchedFlights = false;
        try {
          const data = await ledgerService.searchFlightsByDateRange(this.searchStartDate, this.searchEndDate);
          this.searchFlightsResults = data.flights || [];
          this.hasSearchedFlights = true;
        } catch (error) {
          console.error("Failed to search flights:", error);
          this.searchFlightsResults = [];
        } finally {
          this.isSearchingFlights = false;
        }
      },
      openInvoiceFromSearch(invoiceId) {
        this.showFlightSearch = false;
        this.$router.push('/invoices');
        this.$nextTick(() => {
          EventBus.$emit('loadInvoiceById', invoiceId);
        });
      },
      goToFlightSearchReport () {
        this.showFlightSearch = false;
        this.$router.push({ path: 'flightsearchreport', query: { startDate: this.searchStartDate, endDate: this.searchEndDate } });
        this.pageDidChange('Flight Search Report');
      },
      refreshInquiries () {
        this.$store.dispatch('inquiries/fetchAll');
      },
      openInquiryPage () {
        this.showInquiryPopup = false;
        this.$router.push('/inquiries');
        this.pageDidChange('Inquiries');
      },
      customerFilter (item, queryText) {
        const name = item.name ? item.name.toLowerCase() : '';
        const phone = item.mobileNumber ? item.mobileNumber.toLowerCase() : (item.contactNumber ? item.contactNumber.toLowerCase() : '');
        const query = queryText.toLowerCase();
        return name.includes(query) || phone.includes(query);
      },
      getLocalFileUrl (file) {
        if (!file) return '';
        return URL.createObjectURL(file);
      },

      isLocalImage (file) {
        if (!file) return false;
        if (file.type && file.type.startsWith('image/')) return true;
        return /\.(jpg|jpeg|png|webp|gif|svg)$/i.test(file.name);
      },

      getFileExtension (filename) {
        if (!filename) return '';
        const parts = filename.split('.');
        return parts.length > 1 ? parts.pop().toUpperCase() : '';
      },

      onQuickAddAttachments (files) {
        if (!files) return;
        const list = Array.isArray(files) ? files : [files];
        list.forEach(f => { if (f) this.quickInquiry.attachments.push(f); });
      },

      removeQuickAttachment (index) {
        this.quickInquiry.attachments.splice(index, 1);
      },

      openQuickNewInquiry () {
        if (!this.$store.state.customers.allCustomers.items || this.$store.state.customers.allCustomers.items.length === 0) {
          this.$store.dispatch('customers/getAll');
        }
        this.showInquiryPopup = false;
        this.quickInquiry = { title: '', description: '', category: 'Flight Booking', customCategory: '', priority: 'Medium', customerId: null, customerName: '', customerPhone: '', customerEmail: '', flightStartDate: '', flightEndDate: '', attachments: [] };
        this.quickInquiryError = null;
        this.showQuickInquiryDialog = true;
      },
      onQuickCustomerSelect (val) {
        if (typeof val === 'object' && val !== null) {
          this.quickInquiry.customerId = val.id
          this.quickInquiry.customerName = val.name
          this.quickInquiry.customerPhone = val.mobileNumber || val.contactNumber || ''
          this.quickInquiry.customerEmail = val.email || ''
        } else {
          this.quickInquiry.customerId = null
          this.quickInquiry.customerName = val || ''
        }
      },

      phoneFilter (item, queryText) {
        const phone = item.mobileNumber ? item.mobileNumber.toLowerCase() : (item.contactNumber ? item.contactNumber.toLowerCase() : '');
        const name = item.name ? item.name.toLowerCase() : '';
        const query = queryText.toLowerCase();
        return phone.includes(query) || name.includes(query);
      },

      getPhoneDisplay (item) {
        if (!item || typeof item !== 'object') return item || '';
        return item.mobileNumber || item.contactNumber || item.name || '';
      },

      onQuickCustomerPhoneSelect (val) {
        if (typeof val === 'object' && val !== null) {
          this.quickInquiry.customerId = val.id;
          this.quickInquiry.customerName = val.name;
          this.quickInquiry.customerPhone = val.mobileNumber || val.contactNumber || '';
          this.quickInquiry.customerEmail = val.email || '';
        } else {
          this.quickInquiry.customerPhone = val || '';
        }
      },
      onQuickCategoryChange (val) {
        if (val === 'Umrah Package' && !this.quickInquiry.description) {
          this.quickInquiry.description = 'Flight: \nVisa: \nTransfer: \nZiarat: \nMakkah Hotel (how many nights): \nMadinah Hotel (how many nights): \nPassengers (Adult / Child / Youth): ';
        }
      },
      async submitQuickInquiry () {
        if (!this.quickInquiry.title || !this.quickInquiry.category) {
          this.quickInquiryError = 'Title and category are required.';
          return;
        }
        this.isCreatingQuickInquiry = true;
        this.quickInquiryError = null;
        // Resolve phone in case it's still an object from combobox
        const payload = { ...this.quickInquiry };
        if (typeof payload.customerPhone === 'object' && payload.customerPhone !== null) {
          payload.customerPhone = payload.customerPhone.mobileNumber || payload.customerPhone.contactNumber || '';
        }
        try {
          await this.$store.dispatch('inquiries/create', payload);
          this.showQuickInquiryDialog = false;
        } catch (e) {
          this.quickInquiryError = 'Failed to create inquiry. Please try again.';
        } finally {
          this.isCreatingQuickInquiry = false;
        }
      },
      inquiryPriorityColor (p) {
        return { Urgent: 'red', High: 'orange', Medium: 'blue', Low: 'grey' }[p] || 'grey';
      },

      // --- Flight SMS Reminder Methods ---
      fetchPendingReminders () {
        // Only fetch for admin users — non-admins don't have access to this endpoint
        if (!this.$store.getters['account/isAdmin']) return;
        smsService.getPendingFlightReminders()
          .then(data => {
            if (data && data.reminders && data.reminders.length > 0) {
              this.pendingFlightReminders = data.reminders;
              this.showReminderBanner = true;
            } else {
              this.pendingFlightReminders = [];
              this.showReminderBanner = false;
            }
          })
          .catch(err => {
            console.error('[Reminder] Failed to fetch pending reminders:', err);
          });
      },
      openReminderDialog () {
        // Pre-select all reminders when dialog opens
        this.selectedReminderIds = this.pendingFlightReminders.map(r => r.invoiceId);
        this.allRemindersSelected = true;
        this.reminderSendResult = null;
        this.showReminderDialog = true;
      },
      toggleAllReminders (val) {
        if (val) {
          this.selectedReminderIds = this.pendingFlightReminders.map(r => r.invoiceId);
        } else {
          this.selectedReminderIds = [];
        }
      },
      insertPlaceholder (tag) {
        this.reminderTemplate = (this.reminderTemplate || '') + tag;
      },
      resetReminderTemplate () {
        this.reminderTemplate = this.defaultReminderTemplate;
      },
      async confirmSendReminders () {
        if (this.selectedReminderIds.length === 0) return;
        this.isSendingReminders = true;
        try {
          const result = await smsService.sendFlightReminders(this.selectedReminderIds, this.reminderTemplate);
          const sent = result ? result.sent : this.selectedReminderIds.length;
          const failed = result ? result.failed : 0;
          this.reminderSendResult = `${sent} SMS sent successfully${failed > 0 ? `, ${failed} failed` : ''}.`;
          this.reminderSendResultType = failed > 0 ? 'error' : 'success';
          // Refresh the list — sent flights are now marked smsSent=true
          this.fetchPendingReminders();
        } catch (err) {
          this.reminderSendResult = `Failed to send: ${err}`;
          this.reminderSendResultType = 'error';
        } finally {
          this.isSendingReminders = false;
        }
      },
      closeReminderDialog () {
        this.showReminderDialog = false;
        this.selectedReminderIds = [];
        this.allRemindersSelected = false;
        this.reminderSendResult = null;
        this.reminderSendResultType = 'success';
      }
    },
    beforeDestroy () {
      if (this.notificationPollTimer) {
        clearInterval(this.notificationPollTimer);
      }
    }
  }
</script>

<style scoped>
/* Attachment Previews */
.attachment-preview-container {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  margin-top: 10px;
}
.attachment-preview-card {
  position: relative;
  width: 90px;
  height: 90px;
  border-radius: 8px;
  border: 1px solid #e0e0e0;
  background-color: #f5f5f5;
  overflow: hidden;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
  transition: all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.attachment-preview-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.12);
  border-color: #1976d2;
}
.preview-link {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  text-decoration: none;
  position: relative;
}
.preview-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.preview-file-placeholder {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  padding: 8px;
}
.preview-file-ext {
  font-size: 10px;
  font-weight: 700;
  color: #757575;
  margin-top: 4px;
}
.preview-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.4);
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 0;
  transition: opacity 0.2s ease;
}
.preview-link:hover .preview-overlay {
  opacity: 1;
}
.preview-filename {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  background-color: rgba(255, 255, 255, 0.9);
  color: #37474f;
  font-size: 9px;
  padding: 2px 6px;
  text-align: center;
  font-weight: 500;
  border-top: 1px solid #e0e0e0;
}
.preview-remove-btn {
  position: absolute;
  top: 4px;
  right: 4px;
  background-color: rgba(255, 255, 255, 0.9) !important;
  box-shadow: 0 1px 3px rgba(0,0,0,0.2);
  z-index: 2;
}
.preview-remove-btn:hover {
  background-color: #ffebee !important;
}
</style>